import {Step1} from "./Step1";

export function ResetPassword(props) {

  return (
    <div className="bg-gradient-to-b from-indigo-500 h-[100vh]" id="boxR">
      <Step1/>
    </div>
  )
}